import {useContext} from 'react';
import {Field, Panel} from '../../../../layouts';
import {RetailOrderContext} from '../context/RetailOrderContext';

export default function CFIInformationPanel() {

    const {order} = useContext(RetailOrderContext);

    return (
        <>
            <Panel header={'CFI Information'}>
                <Field label={'Installation Partner'}>{order.details.installationPartner}</Field>
                <Field label={'Phone Number'}>{order.details.installationPartnerPhoneNumber}</Field>
            </Panel>
        </>
    );
}
